import ReportMediator from './ReportMediator'
import $ from 'jquery'
import PDFPreviewLightbox from './estimatedVsActualReport/PDFPreviewLightbox'
import PDFGenerator from '../pdf/evaReport/PDFGenerator'
import {ReportGroupingLevel, ReportType} from './constants'
import BudgetedVsActualResultConfigController from './edit_config_controller/BudgetedVsActualResultConfigController'
import ReportPrintableHeadersBuilder from './ReportPrintableHeadersBuilder'
import messageResource from '../messageResource'
import {ReportConfigConstants} from 'constants'
import makeRpcCall from '../util/jquery_rpc'
import {downloadJsonAsCSV} from '../csv/utils'

export default function BudgetedVsActualReportMediator()
{
    this.constructor = BudgetedVsActualReportMediator;
}

BudgetedVsActualReportMediator.prototype = new ReportMediator();

BudgetedVsActualReportMediator.prototype.init = function(config)
{
    ReportMediator.prototype.init.call(this, config);
    this._initStore(config);
    this._initControllers();

    this.eventNamespace = "EVAReport";
    this.store = EVAReport.Store;

    const oldIE = isOldIE()
    if (!oldIE)
    {
        this.productSettingsValidator = new ATProductSettingsValidator();
        this.reportRightsValidator = new ATReportRightsValidator();

        new BaseReport.PDFPreviewLightboxTemplateView(
            $("body"),
            "leaveTimeAndBalancesPdfPreviewLightbox",
            "lightboxWithWhiteContent pdfPreviewLightbox noprint"
        ).init()

        this.pdfPreviewLightbox = new PDFPreviewLightbox().init(
                {
                    popupId: "leaveTimeAndBalancesPdfPreviewLightbox",
                    closeBtnId: "closeViewTTPdfPreviewLightboxButton",
                    eventNamespace: this.eventNamespace,
                    productSettingsValidator: this.productSettingsValidator,
                    reportRightsValidator: this.reportRightsValidator
                });

        this.initPDFEvents();
    }
    
    this.initCSVEvents();
    
    this.setConfigDateRangeSelection(this.dateRangeSelector.getSelectedRange());
    
    return this;
};

BudgetedVsActualReportMediator.prototype.cancelAllPDFExportingProcesses = function()
{
    if (this.pdfGenerator)
        this.pdfGenerator.interruptGeneration();
    this.pdfPreviewLightbox.cancelAllExportingProcesses();
};

BudgetedVsActualReportMediator.prototype.generatePDF = function()
{
    this.pdfGenerator = new PDFGenerator().init(this.store, ATReportsStore, this.productSettingsValidator, this.reportRightsValidator)

    $(document).trigger(this.getEventName("pdfGenerator.start"));
    const self = this
    this.pdfGenerator.generatePDF(function(config, onDataProvided) {}).then(
            function(pdf)
            {
                self.store.setGeneratedPDF(pdf.encodedPDF);
                self.store.setPDFFileName(pdf.fileName);
            },
            function(error)
            {
                if (error.message !== "abort")
                {
                    console.error(error);
                }
            });
};

BudgetedVsActualReportMediator.prototype._initStore = function(config)
{
    ATReportsStore.setCPList(config.cpList);
};

BudgetedVsActualReportMediator.prototype.getEventName = function(event)
{
    return this.eventNamespace + "." + event;
};

BudgetedVsActualReportMediator.prototype._initControllers = function()
{
    const self = this
    const oldIE = isOldIE()
    this.ExportSelector = new ExportPanel($("body"), oldIE ? null : "EVAReport.showPDFPreview", "EVAReport.createCSV").init();

    this.$exportButton = $(".export");
    this.$exportButton.click(function() { if (!self.$exportButton.hasClass('disabled'))  self.ExportSelector.showAt($(this)); });

    if (oldIE) // IE8 and IE9 don't support pdf preview and pdf generate
    {
        ReportUtils.generateOldIEPDFTooltip(this.ExportSelector.findPDFButton());
    }
};

BudgetedVsActualReportMediator.prototype.generateCSV = function()
{
    const customersMap = _.extend(arrayToMapById(ATReportsStore.getCPList().customers), EVAReport.Store.getCustomers())
    const projectMap = _.extend(arrayToMapById(ATReportsStore.getCPList().projects), EVAReport.Store.getProjects())
    const tasksMap = EVAReport.Store.getTasks()
    const usersMap = EVAReport.Store.getUsers()
    const projectNamesMap = EVAReport.Store.getProjectNames()
    const taskNamesMap = EVAReport.Store.getTaskNames()
    const typesOfWorkMap = EVAReport.Store.getTypesOfWork()

    const generator = new EVACSVJsonConverter().init(
        customersMap,
        projectMap,
        tasksMap,
        usersMap,
        projectNamesMap,
        taskNamesMap,
        typesOfWorkMap,
        null,
        EVAReport.Store.getGroupingPresentationFlags(),
        EVAReport.Store
    )

    downloadJsonAsCSV(
        generator.getJsons(EVAReport.Store.getReportParams(), EVAReport.Store.getReportData()),
        generator.generateCSVName(EVAReport.Store.getReportParams())
    )
};

BudgetedVsActualReportMediator.prototype.getReportType = function()
{
    return ReportType.ESTIMATED_VS_ACTUAL;
};

BudgetedVsActualReportMediator.prototype.initEditConfigController = function(config)
{
    const self = this
    this.controller = new BudgetedVsActualResultConfigController().init(
            {
                reportParameters: config.reportParameters,
                cpList: config.cpList,
                customersWithMaIds: config.customersWithMaIds,
                projectsWithMaIds: config.projectsWithMaIds,
                changeCallback: function() { self.changeParametersCallback(); }
            });
    return this.controller;
};

BudgetedVsActualReportMediator.prototype.createDateRangeSelector = function(reportParameters)
{
    const dateRangeSelectorConfig = {
        dateRangeSelection: reportParameters.dateSelection,
        menuStates: new DateRangeMenuItemsUtil().createDefaultSingleDateMenuItems(),
        dateRangeParsed: true
    };

    return new SingleDateSelectorController().init(dateRangeSelectorConfig);
};

BudgetedVsActualReportMediator.prototype.setDateRangeParameter = function(reportParameters)
{
    this.dateRangeSelector.setSelectedRange(reportParameters.dateSelection);
};

BudgetedVsActualReportMediator.prototype.onDateRangeChanged = function()
{
    this.setConfigDateRangeSelection(this.dateRangeSelector.getSelectedRange());

    if (this.hasErrors())
        return;

    this.dateRangeSelector.setInitStateFromCurrent();
    this.registerChanges();
    this._createPrintableHeaders();
    this.generateReport(false); // do not verify if date range really changed
};

BudgetedVsActualReportMediator.prototype.setConfigDateRangeSelection = function(selection)
{
    this.reportParameters.dateSelection = selection;
};

BudgetedVsActualReportMediator.prototype._populateHeadersArray = function(headersArray)
{
    this.printableHeadersBuilder.addCPSelectionParamsStringToArray(this.reportParameters.customersProjectsSelection, headersArray); //customers and projects
    this.printableHeadersBuilder.addTaskSelectionParamsStringToArray(
            this.reportParameters.tasksConfig,
            this.reportParameters.includeNotEstimated,
            this.reportParameters.includeNotStarted,
            this.reportParameters.dateSelection,
            headersArray
    ); //tasks
};

BudgetedVsActualReportMediator.prototype.initPrintableHeadersBuilder = function(config)
{
    return new ReportPrintableHeadersBuilder().init(
            {
                reportParameters: config.reportParameters,
                cpList: config.cpList,
                isFilteredByAssignments: config.isFilteredByAssignments
            }
    );
};

BudgetedVsActualReportMediator.prototype._createPrintableDateRangeHeader = function()
{
    return this.printableHeadersBuilder.addEvaDateHeaderStringParsed(this.reportParameters.dateSelection);
};

BudgetedVsActualReportMediator.prototype.requestGenerateReport = function(successHandler)
{
    // service
    const self = this

    function successMethod(data, textStatus, jqXHR)
    {
        if (successHandler)
            successHandler(data, textStatus, jqXHR);
        self.$exportButton.toggleClass('disabled', false);
    }

    function errorMethod(jqXHR, textStatus, errorThrown)
    {
        self.$exportButton.toggleClass('disabled', true);

        if (textStatus === "rpc_noRights")
        {
            alert(messageResource.getMessage("common.no_rights_for_operation_anymore"));
            document.location.href = ReportConfigConstants.SAVED_REPORTS_PAGE_URL;
            return true;
        }
        return false;
    }

    const params = this.makeServiceParams(this.reportParameters)
    return makeRpcCall("EvAReportService.getReport",
                       [
                           params.dateSelection,
                           EVAReport.ConvertUtils.getGroupingLevels(params),
                           params.customersProjectsSelection,
                           params.tasksConfig,
                           params.includeNotStarted,
                           params.includeNotEstimated
                       ],
                       successMethod,
                       errorMethod
    )
};

BudgetedVsActualReportMediator.prototype.makeServiceParams = function (reportParams) {
    let serviceParams = _.clone(reportParams)
    serviceParams.dateSelection = {
        qualifier: reportParams.dateSelection.qualifier,
        date: reportParams.dateSelection.date.toJSON()
    };

    return serviceParams;
};

BudgetedVsActualReportMediator.prototype.renderGeneratedReport = function(data)
{
    const reportParams = $.extend(true, {}, this.reportParameters)

    let info = {}
    const groupingLevels = EVAReport.ConvertUtils.getGroupingLevels(reportParams)
    const groupingLevelsCollapsed = EVAReport.ConvertUtils.getGroupingLevelsCollapsed(groupingLevels)

    for (let i = 0; i < data["groupingLevelsInfoLists"].length; ++i) {
        info[groupingLevelsCollapsed[i]] = data["groupingLevelsInfoLists"][i];
    }

    const customers = arrayToMapById(info[ReportGroupingLevel.CUSTOMER])
    const projects = arrayToMapById(info[ReportGroupingLevel.PROJECT])
    const projectNames = arrayToMapById(info[ReportGroupingLevel.PROJECT_NAME])
    const tasks = arrayToMapById(info[ReportGroupingLevel.TASK])
    const taskNames = arrayToMapById(info[ReportGroupingLevel.TASK_NAME])
    const typesOfWork = arrayToMapById(info[ReportGroupingLevel.BILLING_TYPE])
    const users = arrayToMapById(info[ReportGroupingLevel.USER])

    this.reportPlaceholder.empty();
    EVAReport.Store.setReportData(data["rootItem"], customers, projects, tasks, users, projectNames, taskNames, typesOfWork);
    EVAReport.Store.setReportParams(reportParams);

    new EVAReport.Table(this.reportPlaceholder, EVAReport.Store).init().update();
};


// WEBPACK FOOTER //
// ./web/js/reports/BudgetedVsActualReportMediator.js